export default __webpack_public_path__ + "static/media/goshen94.93213207.jpg";